<template>
	<div>
		<div class="pointer accent_color"
			 @click="getDetail"
		>
			{{ referenceNumber }}
		</div>
	</div>
</template>

<script>

export default {
	computed: {
		referenceNumber() {
			return this.params.data[this.params.colDef.field]
		},
		soldReceivablesFunc() {
			return this.params.soldReceivablesFunc;
		},
	},
	methods: {
		getDetail() {
			this.$store.dispatch("setActionNoticModal", {
				show: true,
				data: {
					title: this.referenceNumber,
					type: "RevolvingPutOptionContractDetailsModal",
					width: 600,
					data: {
						revolvingPutOption: this.params.data,
						soldReceivablesFunc: this.soldReceivablesFunc
					}
				}
			});
		}
	},
};
</script>